import React from "react";
import { RiMapPinLine, RiBuildingLine, RiUserLine } from "react-icons/ri";
import SectionNavigation from "../../Utility/SectionNavigation";

const navItems = [
  { id: "tag-mapping", icon: RiMapPinLine, label: "Tag Mapping" },
  { id: "client-qb-mapping", icon: RiBuildingLine, label: "Client QB Mapping" },
  { id: "user-rate-mapping", icon: RiUserLine, label: "User Rate Mapping" },
];

const BillingConfigurationNavigation = ({ activeTab, onTabChange }) => {
  return <SectionNavigation items={navItems} activeTab={activeTab} onTabChange={onTabChange} />;
};

export default BillingConfigurationNavigation;
